import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Annotation } from '@shared/models/annotation.model';

@Component({
  selector: 'quiz-results',
  templateUrl: './quiz-results.component.html',
  styleUrls: ['./quiz-results.component.scss']
})
export class QuizResultsComponent implements OnInit {
  public noData = false;
  @Input() quizzes: Annotation[];
  @Input() date_from: Date;
  @Input() date_to: Date;
  @Input() search: string;
  @Output() onSearch = new EventEmitter<{name: string}>();
  constructor(
  ) {

  }

  ngOnInit(): void {
    if (this.quizzes.length === 0) {
      this.noData = true;
    }

  }
  searchQuizResults(userName: string){
    this.onSearch.emit({name: userName});
    this.search = userName;
  }

}
